import { Popover } from 'bootstrap' // Used in initTooltips
//import { nbeatselect, nbeatmenu, nbeatradio, nbeatcheckbox, nbeatsearchbar } from './nbeat.min.js'

/**
 * Initialize select boxes
 */
function initSelectBoxes() {
    var selectConfig = {
        "sortBy": "score",
        "preSelection": false,
        "autoSubmit": true,
        "formId": "courseSearch"
    };
    $("select.nbeatselect").nbeatselect(selectConfig);
}
 
$(function () {

    $(".nbeatmenu").nbeatmenu();
    //initSelectBoxes(); // Dropdown med tekstfelt sluttet � funke etter oppgraderinger
    initGridAccordions();
    initTooltips();
    initNbeatControls();
    removeUnwantedBorders();
    

    /**
     * Initialize grid accordions
     */
    function initNbeatControls()
    {
        if ($(".nbeatradio").length) {
            $(".nbeatradio").nbeatradio();
        }
        if ($(".nbeatcheckbox").length) {
            $(".nbeatcheckbox").nbeatcheckbox();
        }
        if ($(".nbeatsearchbar").length) {
            $(".nbeatsearchbar").nbeatsearchbar();
        }
    }



    /**
     * Initialize grid accordions
     */
    function initGridAccordions()
    {
        if ($(".nbeatgridaccordion").length) {
            $(".nbeatgridaccordion").nbeatgridaccordion();
        }
    }


    function initTooltips() {
        $(function() {
            $('[data-bs-toggle="popover"]').popover();
        });
    }

    /**
     * Removing unwanted borders
     */
    function removeUnwantedBorders() {
        var x = document.getElementsByClassName("RemoveParentBorder");

        var index;
        for (index = 0; index < x.length; ++index) {
            $(x[index]).parent().css({ "border": "none" });
        }
    }

    
    $(window).on('resize', function () {
        // doThing();
    })

});
